module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Fioo3X/tc-custom/9780226227436.jpg?1705492863980",
      "alt": "This image is the cover for the book Freak Show"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Freak Show\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("This cultural history of the travelling freak show in America chronicles the rise and fall of the industry as attitudes about disability evolved.")])]), _c('p', [_vm._v("From 1840 until 1940, hundreds of freak shows crisscrossed the United States, from the smallest towns to the largest cities, exhibiting their casts of dwarfs, giants, Siamese twins, bearded ladies, savages, snake charmers, fire eaters, and other oddities. By today’s standards such displays would be considered cruel and exploitative—the pornography of disability. Yet for one hundred years the freak show was widely accepted as one of America’s most popular forms of entertainment.")]), _vm._v(" Robert Bogdan’s fascinating social history brings to life the world of the freak show and explores the culture that nurtured and, later, abandoned it. In uncovering this neglected chapter of show business, he describes in detail the flimflam artistry behind the shows, the promoters and the audiences, and the gradual evolution of public opinion from awe to embarrassment. Freaks were not born, Bogdan reveals; they were manufactured by the amusement world, usually with the active participation of the freaks themselves. Many of the \"human curiosities\" found fame and fortune, until the ascent of professional medicine transformed them from marvels into pathological specimens.\n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Robert Bogdan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Robert Bogdan is professor of special education, cultural foundations of education, and sociology at Syracuse University.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The University of Chicago Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0